// extracted by mini-css-extract-plugin
export default {"page-wrapper":"PageWrapper_page-wrapper__G2k4p"};